import { Injectable } from "@angular/core";

import { AppSettings } from "@mrdm-self-service-frontend/shared/types";

import {
    IMatomoCommonDimensionIds,
    IMatomoConfiguration,
    IMatomoDimension,
    MatomoStatsUrl,
} from "@logex/framework/lg-application";

@Injectable({ providedIn: "root" })
export class MatomoConfiguration implements IMatomoConfiguration {
    statUrl: string;
    siteId!: number;
    commonDimensionIds: IMatomoCommonDimensionIds;
    customDimensions = (): IMatomoDimension[] => this._getCustomDimensions();
    autoInit: boolean;
    autoTrack: boolean;
    configuration: AppSettings | undefined;

    private _organizationId: number | undefined;
    private _registryId: string | undefined;

    constructor() {
        this.statUrl = MatomoStatsUrl.MRDM;
        this.commonDimensionIds = {};
        this.autoInit = true;
        this.autoTrack = true;
    }

    configure(config: AppSettings): void {
        if (this.configuration)
            throw new Error("Configuration was already set");
        this.configuration = config;
        this.siteId = config.matomo?.siteId;
    }

    doNotDoMatTracking(): boolean {
        return window.location.hostname === "localhost";
    }

    setOrganizationId(organizationId: number): void {
        this._organizationId = organizationId;
    }

    _getCustomDimensions(): IMatomoDimension[] {
        const result: IMatomoDimension[] = [];

        if (this._organizationId) {
            result.push({
                id: this.configuration!.matomo.organizationDimensionId,
                value: this._organizationId,
            });
        }

        if (this._registryId) {
            result.push({
                id: this.configuration!.matomo.registryDimensionId,
                value: this._registryId,
            });
        }

        return result;
    }
}
